/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/production': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.478 0 0 4.478 0 10s4.478 10 10 10 10-4.478 10-10S15.522 0 10 0zm3.646 15.702l-1.578 1.592-.711-.704 1.229-1.239L11.247 14H8.768l-1.351 1.351 1.238 1.237-.707.707-1.592-1.591a.503.503 0 010-.707L8 13.354 8.354 13H9v-1.9c.5.188 1.391.268 2 .08V13h.664l.336.338 1.646 1.66a.502.502 0 010 .704zm-1.212-5.893c-.586.586-1.354.879-2.121.879s-1.535-.293-2.121-.879a2.998 2.998 0 010-4.242l3.405-3.406a8.02 8.02 0 015.065 3.419l-4.228 4.229z"/><circle pid="1" cx="10" cy="8" r="1"/>'
  }
})
